import { useState, useEffect } from "react";
import HelpHero from "./HelpHero";
import Categories from "./Categories";
import FAQAccordion from "./FAQAccordion";
import Footer from "../landing/Footer";

export default function HelpCenterLayout() {
  const [selectedCategory, setSelectedCategory] = useState("get-started");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setSelectedCategory("get-started");
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    // Clear search when category changes
    if (query === "") {
      setSearchQuery("");
    }
  };

  return (
    <div className="pt-20 min-h-screen bg-emerald-50">
      <HelpHero onSearch={handleSearch} />

      <div className="px-4 mx-auto max-w-6xl sm:px-6">
        <Categories selected={selectedCategory} onSelect={(category) => {
          setSelectedCategory(category);
          setSearchQuery(""); // Clear search when category changes
        }} />

        <div className="mt-10 mb-16">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Frequently Asked Questions</h2>
            <p className="text-sm text-gray-600 max-w-2xl mx-auto">
              Find answers to common questions about TripSecure's services. Still need help? 
              <button type="button" className="text-emerald-600 hover:text-emerald-700 underline ml-1">
                Contact our support team
              </button>
            </p>
          </div>
          <FAQAccordion selectedCategory={selectedCategory} searchQuery={searchQuery} />
        </div>
      </div>
      <Footer/>
    </div>
  );
}


